import Immutable from 'immutable';
import { createSelector } from 'reselect';

/**
 * This will keep track of
 * - menu
 * - locattion
 * - actions for page
 * - flash messages
 */

const FLASH_INFO = 'app/FLASH_INFO';
const FLASH_SUCCESS = 'app/FLASH_SUCCESS';
const FLASH_ERROR = 'app/FLASH_ERROR';
const SEND_MESSAGE_DIALOG_OPEN = 'app/SEND_MESSAGE_MODAL_OPEN';
const SEND_MESSAGE_DIALOG_CLOSE = 'app/SEND_MESSAGE_MODAL_CLOSE';

const initialState = Immutable.fromJS({
  isSendMessageDialogOpen: false,
  flash: []
});

export default (state = initialState, action) => {
  switch (action.type) {
    case FLASH_INFO:
      return state.flash.push({ type: 'info', msg: action.msg, stamp: Date.now() });
    case FLASH_SUCCESS:
      return state.flash.push({ type: 'success', msg: action.msg, stamp: Date.now() });
    case FLASH_ERROR:
      return state.flash.push({ type: 'error', msg: action.msg, stamp: Date.now() });
    case SEND_MESSAGE_DIALOG_OPEN: {
      return state.set('isSendMessageDialogOpen', true);
    }
    case SEND_MESSAGE_DIALOG_CLOSE: {
      return state.set('isSendMessageDialogOpen', false);
    }

    case 'FLUSH':
      return initialState;

    default:
      return state;
  }
};

/**
 * Flash info message
 * @param {string} msg
 */
export const flashInfo = (msg) => ({ type: FLASH_INFO, msg });

/**
 * Flash success message
 * @param {string} msg
 */
export const flashSuccess = (msg) => ({ type: FLASH_SUCCESS, msg });

/**
 * Flash error message
 * @param {string} msg
 */
export const flashError = (msg) => ({ type: FLASH_ERROR, msg });

export const showSendMessageDialog = () => {
  return { type: SEND_MESSAGE_DIALOG_OPEN };
};

export const hideSendMessageDialog = () => ({ type: SEND_MESSAGE_DIALOG_CLOSE });

export const getIsSendMessageDialogOpen = createSelector(
  (state) => state,
  (state) => state.get('app').get('isSendMessageDialogOpen')
);



// WEBPACK FOOTER //
// ./src/redux/modules/app.js